import styled from 'styled-components';

export const LogSnapshotStyle = styled.pre`
  max-height: 320px;
  overflow: auto;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  padding: 12px;
  margin-top: 12px;
  background: #f6f7fa;
  border-radius: 4px;
  font-size: 12px;
`;

export const PaymentSettingLogStyle = styled.div`
  .log-search-box {
    padding: 24px;
    margin-bottom: 24px;
  }
  .log-search-box .label {
    min-width: 80px;
  }
  .log-search-box .btn-area {
    padding-top: 4px;
  }
  .log-search-box .btn-area button {
    height: 36px;
    padding: 0 20px;
  }
  .log-search-box .ant-select,
  .log-search-box .ant-input-affix-wrapper {
    width: 260px;
    max-width: 100%;
  }
  .log-search-box .ant-picker-range {
    width: 360px;
    max-width: 100%;
  }
  @media (max-width: 680px) {
    .log-search-box {
      padding: 16px;
    }
    .log-search-box .amondz-form {
      align-items: flex-start;
      flex-direction: column;
      gap: 8px;
    }
    .log-search-box .amondz-form .content {
      padding-left: 0;
      min-width: 0;
      width: 100%;
    }
    .log-search-box .btn-area button {
      width: 100px;
    }
  }
  .log-summary {
    line-height: 1.8;
    overflow-wrap: anywhere;
  }
  .ant-table-thead > tr > th {
    background: #f8f9fc;
    color: #626e7f;
    font-size: 12px;
    font-weight: 500;
  }
  .ant-table-tbody > tr > td {
    vertical-align: top;
    font-size: 13px;
    padding-top: 18px;
    padding-bottom: 18px;
  }
  .ant-pagination {
    padding: 0 16px;
  }
`;
